import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StoreService } from 'src/app/services/infra/store/store.service';

@Component({
  selector: 'app-contact-soc-dialog',
  templateUrl: './incident-created-successfully-dialog.component.html',
  styleUrls: ['./incident-created-successfully-dialog.component.scss'],
})
export class IncidentCreatedSuccessfullyDialogComponent implements OnInit {
  @Input() public dynamicSentence: string;

  constructor(
    @Inject(MatDialogRef) public dialogRef: MatDialogRef<IncidentCreatedSuccessfullyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IncidentCreatedSuccessfullyDialogComponent,
    private readonly _store: StoreService
  ) {}

  ngOnInit(): void {
    this.dynamicSentence = this.data.dynamicSentence;
  }

  public onClose(): void {
    this.dialogRef.close();
  }
}
